var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 60,
    viewBox: "0 0 78 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9247 2.07074C38.9428 1.85666 39.256 1.85666 39.2741 2.07074L41.9138 33.3635C41.9528 33.8263 42.0733 34.2786 42.2697 34.6996L51.3175 54.0921C51.4085 54.287 51.1362 54.4428 51.0143 54.2656L40.5435 39.0483C39.8469 38.0359 38.3519 38.0359 37.6553 39.0483L27.1845 54.2656C27.0626 54.4427 26.7903 54.287 26.8813 54.0921L35.9291 34.6996C36.1255 34.2786 36.246 33.8263 36.2851 33.3635L38.9247 2.07074Z",
    fill: "url(#paint0_linear_2_27)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.57896,
    height: 0.542706,
    transform: "matrix(-0.707142 0.707071 -0.707142 -0.707071 20.8485 47.8701)",
    fill: "url(#paint1_linear_2_27)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.57896,
    height: 0.542706,
    transform: "matrix(0.707159 0.707055 0.707159 -0.707055 57.9286 47.8701)",
    fill: "url(#paint2_linear_2_27)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.916913,
    height: 0.542706,
    transform: "matrix(0.707142 -0.707071 -0.707142 -0.707071 17.8466 50.8718)",
    fill: "url(#paint3_linear_2_27)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.22759,
    height: 0.542706,
    transform: "matrix(0.707142 -0.707071 -0.707142 -0.707071 17.1474 51.571)",
    fill: "url(#paint4_linear_2_27)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 0.916913,
    height: 0.542706,
    transform: "matrix(-0.707159 -0.707055 0.707159 -0.707055 60.9306 50.8718)",
    fill: "url(#paint5_linear_2_27)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.134146,
    height: 0.542706,
    transform: "matrix(-0.707159 -0.707055 0.707159 -0.707055 61.4931 51.4329)",
    fill: "url(#paint6_linear_2_27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7366 46.4681L47.4576 37.1904C46.0546 35.7877 45.1425 33.9692 44.8572 32.0059L41.245 7.14899",
    stroke: "url(#paint7_linear_2_27)",
    strokeWidth: 0.438242
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.4373 46.4681L55.889 36.9212C54.6534 35.6859 53.7951 34.1243 53.4142 32.4192L47.7704 7.14899",
    stroke: "url(#paint8_linear_2_27)",
    strokeWidth: 0.438242,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7026 46.4681L30.9817 37.1904C32.3846 35.7877 33.2967 33.9692 33.582 32.0059L37.1942 7.14899",
    stroke: "url(#paint9_linear_2_27)",
    strokeWidth: 0.438242
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 46.4681L22.5483 36.9212C23.7839 35.6859 24.6422 34.1243 25.023 32.4192L30.6669 7.14899",
    stroke: "url(#paint10_linear_2_27)",
    strokeWidth: 0.438242,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.9517 23.5915L33.8583 12.8681",
    stroke: "url(#paint11_linear_2_27)",
    strokeWidth: 0.438242
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M47.9191 31.9318L46.4892 23.3531",
    stroke: "url(#paint12_linear_2_27)",
    strokeWidth: 0.438242
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M45.0595 17.396L44.5829 14.0595",
    stroke: "url(#paint13_linear_2_27)",
    strokeWidth: 0.438242
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.0028 3.33655L36.2411 1.90662",
    stroke: "url(#paint14_linear_2_27)",
    strokeWidth: 0.438242
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_27",
    x1: 59.0214,
    y1: 77.677,
    x2: 18.2605,
    y2: 18.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_27",
    x1: 0.789482,
    y1: 0,
    x2: 0.789482,
    y2: 0.542706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_27",
    x1: 0.789482,
    y1: 0,
    x2: 0.789482,
    y2: 0.542706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_27",
    x1: 0.458456,
    y1: 0,
    x2: 0.458456,
    y2: 0.542706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_27",
    x1: 0.113795,
    y1: 0,
    x2: 0.113795,
    y2: 0.542706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_27",
    x1: 0.458456,
    y1: 0,
    x2: 0.458456,
    y2: 0.542706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_27",
    x1: 0.0670732,
    y1: 0,
    x2: 0.0670732,
    y2: 0.542706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_27",
    x1: 51.3742,
    y1: 7.14899,
    x2: 51.3742,
    y2: 46.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_27",
    x1: 60.0748,
    y1: 7.14899,
    x2: 60.0748,
    y2: 46.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_27",
    x1: 30.7592,
    y1: 8.10218,
    x2: 27.0662,
    y2: 46.4683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_27",
    x1: 22.0566,
    y1: 8.10218,
    x2: 18.3636,
    y2: 46.4683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_27",
    x1: 28.3769,
    y1: 8.10214,
    x2: 24.6836,
    y2: 46.4682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_27",
    x1: 51.4939,
    y1: 16.4424,
    x2: 55.1872,
    y2: 54.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_27",
    x1: 49.5877,
    y1: 6.43322,
    x2: 53.2816,
    y2: 44.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_27",
    x1: 31.9513,
    y1: -8.10289,
    x2: 28.2573,
    y2: 30.2669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket-icon.fc4ee00a095c454c930490c6d24b7ffe.svg";
export { ForwardRef as ReactComponent };